import React from 'react';

const SonarIcon = (props) => (
  <svg {...props} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='13.92 17.86 87.92 82.15'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M40.5136 19.9359L69.649 17.8986C74.932 17.5291 80.0108 20.0062 82.9722 24.3967L99.3043 48.61C102.266 53.0005 102.66 58.6374 100.338 63.3973L87.535 89.648C85.2135 94.4079 80.5289 97.5677 75.2459 97.9371L46.1105 99.9745C40.8275 100.344 35.7487 97.8668 32.7873 93.4763L16.4552 69.263C13.4938 64.8725 13.0996 59.2356 15.4212 54.4757L28.2245 28.225C30.546 23.4651 35.2306 20.3053 40.5136 19.9359Z'
      fill='#FDBF47'
    />
    <path
      d='M57.3477 34.9492L57.9809 44.0052C61.0705 44.0781 63.9589 45.1007 66.3388 46.808L72.2988 39.9517C68.0003 36.6279 62.7807 34.8814 57.3477 34.9492Z'
      fill='#444A52'
    />
    <path
      d='M63.4658 59.993C63.0929 62.1673 61.5252 63.9706 59.424 64.6426L59.8652 70.9515C65.394 69.9163 69.5189 65.1711 69.7746 59.5518L63.4658 59.993Z'
      fill='#444A52'
    />
    <path
      d='M58.1787 46.832L58.6197 53.1387C59.2193 53.2403 59.7972 53.4337 60.3371 53.7133L64.4813 48.946C62.661 47.6992 60.4941 46.9374 58.1787 46.832Z'
      fill='#444A52'
    />
    <path
      d='M59.6622 56.6378C59.662 56.6376 59.6617 56.6374 59.6615 56.6373C59.6613 56.6371 59.6611 56.6368 59.6608 56.6367C59.0323 56.0906 58.229 55.822 57.3985 55.8802C55.6832 56.0001 54.3857 57.4929 54.5056 59.2078C54.6255 60.9228 56.1184 62.2205 57.8334 62.1006C59.5485 61.9806 60.8463 60.4878 60.7264 58.773C60.6683 57.9424 60.2904 57.1841 59.6622 56.6378Z'
      fill='#444A52'
    />
    <path
      d='M51.9641 60.7971L45.6553 61.2383C46.6904 66.7673 51.4357 70.8922 57.0549 71.1478L56.6137 64.8389C54.4394 64.466 52.636 62.8983 51.9641 60.7971Z'
      fill='#444A52'
    />
    <path
      d='M45.4589 58.4279L51.7677 57.9868C52.1407 55.8125 53.7083 54.0092 55.8096 53.3373L55.3685 47.0284C49.8395 48.0636 45.7145 52.8088 45.4589 58.4279Z'
      fill='#444A52'
    />
    <path
      d='M66.6071 50.7939L62.4629 55.5612C62.815 56.057 63.0869 56.6025 63.2712 57.182L69.5776 56.741C69.151 54.463 68.095 52.4231 66.6071 50.7939Z'
      fill='#444A52'
    />
    <path
      d='M42.8285 61.4371L33.7725 62.0703C34.5209 67.9244 37.3523 73.2321 41.8428 77.1355C46.3334 81.039 51.9835 83.1043 57.8847 83.0307L57.2515 73.9748C50.0796 73.8056 43.9942 68.5157 42.8285 61.4371Z'
      fill='#444A52'
    />
    <path
      d='M72.6005 59.3542C72.4314 66.5263 67.1413 72.6117 60.0628 73.7774L60.696 82.8334C66.5501 82.0849 71.8579 79.2535 75.7614 74.7629C79.6648 70.2724 81.73 64.6223 81.6563 58.7211L72.6005 59.3543L72.6005 59.3542Z'
      fill='#444A52'
    />
    <path
      d='M74.4257 41.8019L68.4657 48.6582C70.4876 50.7776 71.9022 53.4953 72.4044 56.5448L81.4604 55.9116C80.7713 50.5217 78.3154 45.5959 74.4257 41.8019Z'
      fill='#444A52'
    />
    <path
      d='M39.471 43.217C35.5675 47.7076 33.5024 53.3576 33.5759 59.2589L42.6319 58.6257C42.801 51.4538 48.0911 45.3684 55.1697 44.2027L54.5365 35.1468C48.6824 35.8951 43.3746 38.7264 39.471 43.217Z'
      fill='#444A52'
    />
  </svg>
);

export default SonarIcon;
